// Comparisons of the built-in studies of TradingView (Std.gt / lt / ge / le
// of charting_library): values closer than this are equal. NaN compares false.
const EPSILON = 1e-10;

/** Std.gt / Std.greater: `value` is above `other`. */
export const isAbove = (value, other) => value - other > EPSILON;

/** Std.lt / Std.less: `value` is below `other`. */
export const isBelow = (value, other) => other - value > EPSILON;

/** Std.ge: `value` is not below `other`. */
export const isAtLeast = (value, other) => value - other >= -EPSILON;

/** Std.le: `value` is not above `other`. */
export const isAtMost = (value, other) => other - value >= -EPSILON;
